// @flow
import SidebarExternalLink from './SidebarExternalLink'

export default SidebarExternalLink
